import { Dialog, DialogActions, DialogContent, DialogTitle, Typography } from '@mui/material';
import Button from '@mui/material/Button';
import { EventOccasion } from 'models/EventOccasion';
import { TrackRequest } from 'models/TrackRequest';
import { useTranslation } from 'react-i18next';

export interface ExportSeratoDialogProps {
  event: EventOccasion;
  tracks: TrackRequest[];
  open: boolean;
  onExport?: (tracks: TrackRequest[]) => void;
  onClose?: () => void;
}

export function ExportSeratoDialog({ tracks, open, onExport, onClose }: ExportSeratoDialogProps) {
  const { t } = useTranslation();

  const handleCloseDialog = () => {
    onClose?.();
  };

  const handleExport = async () => {
    onExport?.(tracks);
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs">
      <DialogTitle variant="h3">{t('exportSeratoTitle', 'Export Serato Crate')}</DialogTitle>
      <DialogContent>
        <Typography variant="body1" gutterBottom>
          {t(
            'exportSeratoDescription',
            'Your playlist will be exported as a Crate directly into Serato DJ. Restart Serato DJ afterwards to see it.'
          )}
        </Typography>
        {/* <FormControlLabel
          control={<Checkbox disabled />}
          label={t('exportSeratoDialogHide', "Don't show this again")}
        /> */}
      </DialogContent>
      <DialogActions>
        <Button onClick={handleCloseDialog}>{t('cancel', 'Cancel')}</Button>
        <Button onClick={handleExport} variant="contained">
          {t('exportSerato', 'Save Crates')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
